/*
 * @Author: your name
 * @Date: 2019-06-16 10:03:09
 * @LastEditTime: 2019-12-01 11:46:04
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \source\src\utility\tdtService\Query\Service\CenterPointKeyWordSearchService.js
 */
import { KeyWordSearchService } from "./KeyWordSearchService";
import { KeyWordServiceUtility } from "../Utility/KeyWordServiceUtility";

/// <summary>
/// 中心点关键字周边搜索
/// </summary>
export class CenterPointKeyWordSearchService extends KeyWordSearchService {

	constructor() {
		super();
		this.centerPointX = -1;
		this.centerPointY = -1;
		this.radiusDistance = -1;
	}


	/**
		 *检查属性是否赋值
		 */
	CheckParams() {
		if (super.CheckParams() == false)
			return false;
		if (this.centerPointX == -1) {
			return false;
		}
		if (this.centerPointY == -1) {
			return false;
		}
		if (this.radiusDistance == -1) {
			return false;
		}
		return true;
	}

	/**
	 * 查询
	 * @param {*} succeedCallback 
	 * @param {*} errorCallback 
	 */
	Query(succeedCallback, errorCallback) {
		let queryService = new KeyWordServiceUtility();
		queryService.centerPointX = this.centerPointX;
		queryService.centerPointY = this.centerPointY;
		queryService.radiusDistance = this.radiusDistance;
		queryService.completeEvent = super.completeEvent;
		super.SetBaseInfoServiceUtility(queryService);
		queryService.Query(succeedCallback, errorCallback);
	}

	/**
	 * 测试用
	 */
	static test() {
		let searchService = new CenterPointKeyWordSearchService();
		searchService.centerPointX = 116.42844;
		searchService.centerPointY = 39.92314;
		searchService.radiusDistance = 5000;
		searchService.keyWord = "超市";
		searchService.level = "15";
		searchService.queryType = "3";
		searchService.count = "20";
		searchService.start = "0";
		searchService.minLat = 39.90684;
		searchService.maxLat = 39.93138;
		searchService.minLon = 116.40466;
		searchService.maxLon = 116.45016;
		searchService.token = "ebddfc3f34215c7375bddd93f03dd684";

		searchService.Query(null, null);
	}


}//end CenterPointKeyWordSearchService

